import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Notary รับรองสำเนาพาสปอร์ต — Certified True Copy สำหรับใช้ต่างประเทศ","metaTitle":"Notary รับรองสำเนาพาสปอร์ต (Certified True Copy) | NYC","metaDesc":"Notarial Attorney รับรองสำเนาพาสปอร์ตถูกต้อง Certified True Copy ยอมรับทั่วโลก + MFA + Apostille ครบวงจร — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"Notary Passport Copy — Certified True Copy for Overseas Use","metaTitle":"Notary Certified True Copy of Passport — Apostille | NYC","metaDesc":"Notarial Attorney certifies true copies of passports for offshore banking, brokerage, and visa filing — Talk to a specialist today; no obligation, fast reply."}} as const;

export const Route = createFileRoute("/en/notary/passport-copy")({
  head: () => {
    const url = `${SEO_SITE}/en/notary/passport-copy`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/notary/passport-copy", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/notary/passport-copy", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/notary/passport-copy", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/notary/passport-copy", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/notary/passport-copy", "/en/notary/passport-copy")],
    };
  },
  component: () => <SubServicePage slug="notary/passport-copy" locale="en" />,
});
